import { partnerServices } from "../../config/axios";
import MyVouchers from "../../views/Vouchers/MyVouchers/MyVouchers";
import {
  GETWALLETTRANSACTIONLISTONPARENT_SUCCESS,
  GETWALLETTRANSACTIONLISTONPARENT_FAILED,
  RESET_GETWALLETTRANSACTIONLISTONPARENT,
  LOADING_GETWALLETTRANSACTIONLISTONPARENT,
  NETWORK_ERROR_GETWALLETTRANSACTIONLISTONPARENT,
} from "../types";

function resetGetWalletTransactionListOnParent() {
  return {
    type: RESET_GETWALLETTRANSACTIONLISTONPARENT,
  };
}

const getWalletTransactionListOnParent =
  (data, authTokenIs) => async (dispatch) => {
    dispatch({
      type: LOADING_GETWALLETTRANSACTIONLISTONPARENT,
    });

    await partnerServices
      .post("getWalletTransactionList", data, {
        headers: { AuthToken: authTokenIs },
      })
      .then((res) => {
        switch (res.status) {
          case 400:
            dispatch(getWalletTransactionListFailed(res.data));
            break;
          case 200:
            dispatch(getWalletTransactionListSuccess(res.data));
            break;
          default:
            dispatch(getWalletTransactionListFailed());
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETWALLETTRANSACTIONLISTONPARENT,
          payload: err,
        });
      });
  };
function getWalletTransactionListFailed(data) {
  return {
    type: GETWALLETTRANSACTIONLISTONPARENT_FAILED,
    payload: data,
  };
}
function getWalletTransactionListSuccess(data) {
  return {
    type: GETWALLETTRANSACTIONLISTONPARENT_SUCCESS,
    payload: data,
  };
}

export {
  getWalletTransactionListOnParent,
  resetGetWalletTransactionListOnParent,
};
